import { Row, Col } from '@sravni/react-design-system/lib/Grid';
import { EmailInput, NameInput, PhoneInput, ServerErrorMessage } from '@sravni/react-silent-authentication-form';
import React, { useCallback } from 'react';

import { AuthInlineFormOtpButton } from 'shared/ui/CustomAuthInlineForm/ui/AuthInlineFormOtpButton';

import { DEFAULT_GUTTER, DEFAULT_OFFSET, DEFAULT_SPAN, SCREENS } from '../constants';
import type { AuthInlineFormProps } from '../types';

import styles from './AuthInlineForm.module.scss';
import { BeforeSlot, AfterSlot } from './Slots';

type Props = Pick<
  AuthInlineFormProps,
  | 'getOTPButtonProps'
  | 'children'
  | 'isEnabledEmailField'
  | 'isEnabledNameField'
  | 'isOTPButtonSticky'
  | 'isEnabledOTPButtonSticky'
> & {
  currentScreen: ValuesOf<typeof SCREENS>;
  setCurrentScreen: React.Dispatch<ValuesOf<typeof SCREENS>>;
};

export const AuthInlineFormFields = (props: Props) => {
  const {
    isEnabledNameField = false,
    isEnabledEmailField = true,
    getOTPButtonProps,
    children,
    currentScreen,
    setCurrentScreen,
    isOTPButtonSticky,
    isEnabledOTPButtonSticky,
  } = props;
  const { isInlineButton = false, ...restOTPButtonProps } = getOTPButtonProps || {};

  const handleGetOTPButtonClick = useCallback(
    (event) => {
      getOTPButtonProps?.onClick?.(event);
      setCurrentScreen(SCREENS.OTP);
    },
    [getOTPButtonProps, setCurrentScreen],
  );

  return (
    <>
      <BeforeSlot.Renderer childs={children} />
      <Row gutter={DEFAULT_GUTTER}>
        {isEnabledNameField && (
          <Col span={DEFAULT_SPAN}>
            <NameInput required />
          </Col>
        )}
        {isEnabledEmailField && (
          <Col span={DEFAULT_SPAN}>
            <EmailInput required />
          </Col>
        )}
        <Col span={DEFAULT_SPAN}>
          <PhoneInput />
        </Col>
        <Col span={DEFAULT_SPAN}>
          {isInlineButton && (
            <AuthInlineFormOtpButton
              currentScreen={currentScreen}
              onClick={handleGetOTPButtonClick}
              isOTPButtonSticky={isOTPButtonSticky}
              isEnabledOTPButtonSticky={isEnabledOTPButtonSticky}
              getOTPButtonProps={restOTPButtonProps}
            />
          )}
        </Col>
        <Col
          span={12}
          className={styles.serverErrorWrapper}
        >
          {currentScreen === SCREENS.INITIAL && <ServerErrorMessage className={styles.serverError} />}
        </Col>
      </Row>
      <AfterSlot.Renderer childs={children} />
      {!isInlineButton && (
        <Row gutter={DEFAULT_GUTTER}>
          <Col
            span={DEFAULT_SPAN}
            offset={DEFAULT_OFFSET}
          >
            <AuthInlineFormOtpButton
              currentScreen={currentScreen}
              onClick={handleGetOTPButtonClick}
              isOTPButtonSticky={isOTPButtonSticky}
              isEnabledOTPButtonSticky={isEnabledOTPButtonSticky}
              getOTPButtonProps={restOTPButtonProps}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
